import { IFarmConfiguration, IUser } from 'src/@types/User'
import { STORAGE_KEYS } from '../constants'

const USER_DATA_KEY = 'userData'

export interface SaveSessionDTO {
  user: IUser
  token: string
  refreshToken: string
  expiresIn: string
  farmConfig?: IFarmConfiguration
}

function safeParseJson<T>(value: string | null): T | null {
  if (!value) return null

  try {
    return JSON.parse(value) as T
  } catch {
    return null
  }
}

export const storageService = {
  saveSession(data: SaveSessionDTO): void {
    localStorage.setItem(STORAGE_KEYS.TOKEN, data.token)
    localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, data.refreshToken)
    localStorage.setItem(STORAGE_KEYS.EXPIRES_IN, data.expiresIn)

    localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(data.user.username))
    localStorage.setItem(STORAGE_KEYS.ID_FAZENDA, data.user.idFazenda)
    localStorage.setItem(STORAGE_KEYS.NAME_USER_LOGGED, `${data.user.nome} ${data.user.sobrenome}`.trim())
    localStorage.setItem(STORAGE_KEYS.PROFILE_USER_LOGGED, data.user.perfil)
    localStorage.setItem(STORAGE_KEYS.PHONE_IS_CONFIRMED, data.user.telefoneConfirmado || '')
    localStorage.setItem(STORAGE_KEYS.EMAIL_IS_CONFIRMED, data.user.emailConfirmado || '')

    localStorage.setItem(USER_DATA_KEY, JSON.stringify(data.user))
    localStorage.setItem(STORAGE_KEYS.FARM_CONFIG, JSON.stringify(data.farmConfig || {}))
  },

  clearSession(): void {
    localStorage.removeItem(STORAGE_KEYS.TOKEN)
    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN)
    localStorage.removeItem(STORAGE_KEYS.EXPIRES_IN)
    localStorage.removeItem(STORAGE_KEYS.USER)
    localStorage.removeItem(STORAGE_KEYS.ID_FAZENDA)
    localStorage.removeItem(STORAGE_KEYS.NAME_USER_LOGGED)
    localStorage.removeItem(STORAGE_KEYS.PROFILE_USER_LOGGED)
    localStorage.removeItem(STORAGE_KEYS.PHONE_IS_CONFIRMED)
    localStorage.removeItem(STORAGE_KEYS.EMAIL_IS_CONFIRMED)
    localStorage.removeItem(USER_DATA_KEY)
    localStorage.removeItem(STORAGE_KEYS.FARM_CONFIG)
  },

  getToken(): string | null {
    return localStorage.getItem(STORAGE_KEYS.TOKEN)
  },

  getRefreshToken(): string | null {
    return localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN)
  },

  getTokenExpiry(): string | null {
    return localStorage.getItem(STORAGE_KEYS.EXPIRES_IN)
  },

  getUser(): IUser | null {
    const userData = safeParseJson<IUser>(localStorage.getItem(USER_DATA_KEY))
    const farmConfig = safeParseJson<IFarmConfiguration>(localStorage.getItem(STORAGE_KEYS.FARM_CONFIG))
    if (userData) return userData

    const username = safeParseJson<string>(localStorage.getItem(STORAGE_KEYS.USER))
    const idFazenda = localStorage.getItem(STORAGE_KEYS.ID_FAZENDA)

    if (!username || !idFazenda) {
      return null
    }

    return {
      idFazenda,
      fazendaBaseId: farmConfig?.idFazenda || null,
      username,
      senha: '',
      nome: (localStorage.getItem(STORAGE_KEYS.NAME_USER_LOGGED) || '').split(' ')[0] || '',
      sobrenome: (localStorage.getItem(STORAGE_KEYS.NAME_USER_LOGGED) || '').split(' ').slice(1).join(' '),
      perfil: localStorage.getItem(STORAGE_KEYS.PROFILE_USER_LOGGED) as IUser['perfil'],
      documento: '',
      telefone: '',
      dataUltimoSync: '',
      versaoAtual: '',
      confirmado: '',
      emailConfirmado: localStorage.getItem(STORAGE_KEYS.EMAIL_IS_CONFIRMED),
      telefoneConfirmado: localStorage.getItem(STORAGE_KEYS.PHONE_IS_CONFIRMED) || '',
      identificacao: null,
      melhoramentoGenetico: null,
      dataCriacao: null,
      senhaResetada: null,
      listPropriedades: [],
      usernameUpperCase: username.toUpperCase(),
      acao: '',
      key: '',
      id: ''
    }
  },

  getFarmConfig(): IFarmConfiguration | null {
    const farmConfig = safeParseJson<IFarmConfiguration>(localStorage.getItem(STORAGE_KEYS.FARM_CONFIG))
    return farmConfig || null
  }
}
